<template>
  <div class="no-access">
    <p class="lead">
      <b>Scholarly Editions</b> would like to grant you access, but you
      do not have the right credentials at the moment.
    </p>
    <p>
       If you would like to get access or have any questions, please <a href="/contact">contact us</a>.
    </p>
  </div>
</template>

<script>
import constants from '@/js/constants';

export default {
  name: 'NoAccess',
  data() {
    return { constants };
  },
  computed: {
    prdCode() {
      return this.$route.params.urn.match(/[A-Za-z]+(?=-)/)[0];
    },
  },
};
</script>
